window.eventRecorder = window.eventRecorder || { cmd: [] };

